import { getEventEmitter } from '@process-advisor/process-miner/processMiner/processMiner';
import { Event } from '@process-advisor/process-miner/api/events';

export type StepMetricsModalProps = {
    data: {
        fromActivity: string,
        toActivity: string,
        avg_comments_customer : any,
        avg_comments_internal : any,
        avg_duration : number,
        avg_worklogs : number,
        comments_customer : number,
        comments_internal : number,
        events : number ,
        tasks: number, 
        max_duration : number,
        min_duration : number,
        perc_comments_customer : number ,
        perc_comments_internal : number,
        perc_total_tasks : number ,
        perc_worklog : number,
        std_deviation : number,
        worklogs : number,
        time_spent: number,
        avg_time_spent: number
    }
}

export const openStepMetricsModal = ({ data }: StepMetricsModalProps) => {
    getEventEmitter().emit(Event.openStepMetricsModal, { data });
};
